var render = function () {
  var _vm$el$thumbnail, _vm$el$thumbnail2, _vm$el$thumbnail3, _vm$el$thumbnail4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nuxt-link', {
    staticClass: "card link link_wu",
    attrs: {
      "to": _vm.el.link
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.onClick(_vm.el);
      }
    }
  }, [_c('div', {
    staticClass: "card__photo"
  }, [_vm.photoLazyload ? [_c('LazyImg', {
    staticClass: "card__photo-img",
    attrs: {
      "img": (_vm$el$thumbnail = _vm.el.thumbnail) === null || _vm$el$thumbnail === void 0 ? void 0 : _vm$el$thumbnail.x1,
      "srcset": (_vm$el$thumbnail2 = _vm.el.thumbnail) === null || _vm$el$thumbnail2 === void 0 ? void 0 : _vm$el$thumbnail2.x2,
      "alt": _vm.el.name
    }
  })] : [(_vm$el$thumbnail3 = _vm.el.thumbnail) !== null && _vm$el$thumbnail3 !== void 0 && _vm$el$thumbnail3.x1 ? _c('img', {
    staticClass: "card__photo-img",
    attrs: {
      "src": _vm.el.thumbnail.x1,
      "srcset": (((_vm$el$thumbnail4 = _vm.el.thumbnail) === null || _vm$el$thumbnail4 === void 0 ? void 0 : _vm$el$thumbnail4.x3) + " 2x"),
      "alt": _vm.el.name
    }
  }) : _c('img', {
    staticClass: "card__photo-img",
    attrs: {
      "src": require("assets/images/empty.svg"),
      "alt": _vm.el.name
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "card__name fz-14 lh-17"
  }, [_vm._v("\n    " + _vm._s(_vm.el.name) + "\n  ")]), _vm._v(" "), _vm.el.price ? _c('div', {
    staticClass: "card__price fz-14 lh-17 b"
  }, [_vm._v("\n    " + _vm._s(_vm.el.price) + "\n  ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }